import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";

import React, { useState } from "react";
import { connect } from "react-redux";
import { getLetterCustomization } from "../../store/structure/actions";
import CustomizedLetter from "./LetterFormat/CustomizedLetter";
import PlanningEntitySwitcher from "../rbm/components/PlanningEntitySwitcher";

const LetterTemplateDialog = (props) => {
  const { selectedPlanningEntityId, user } = props;

  const [isDownloading, setIsDownloading] = useState(false);

  const downloadTemplate = async () => {
    try {
      setIsDownloading(true);

      const response = await fetch(
        "/api/structure/download-template-letter/" +
          user?.selectedEntitySector?.id +
          "/" +
          selectedPlanningEntityId
      );
      const data = await response.json();

      const { filename, mimeType, base64 } = data;
      // Convert Base64 to Blob
      const blob = new Blob(
        [Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))],
        { type: mimeType }
      );

      // Create a URL and trigger download
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setIsDownloading(false);
    } catch (error) {
      alert(error);
      setIsDownloading(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          {/* <button
              onClick={() => downloadTemplate()}
              type="button"
              className="btn btn-primary text-uppercase px-4"
              disabled={!selectedPlanningEntityId}
            >
              Customize
            </button> */}
        </div>

        <PlanningEntitySwitcher color="dark" />
      </div>

      <div className="mx-2 w-full">
        <CustomizedLetter
          disableToEditLetterHeader={false}
          enableToFillLetter={false}
          docLetterNo={".../.../2023"}
          signContent={<></>}
          subTitle={"Dear Joe Deo"}
          onDownload={
            <>
              <button
                onClick={() => downloadTemplate()}
                type="button"
                className="btn btn-primary text-uppercase btn-sm mt-2 px-4 mx-1"
                disabled={!selectedPlanningEntityId || isDownloading}
              >
                Download
              </button>
            </>
          }
          recipientContent={
            <>
              Joe Deo
              <br />
              Tel: +25078888... <br />
              Email: joedeo@gmail.com <br />
            </>
          }
          entitySectorId={user?.selectedEntitySector?.id}
          letterBodyContent={` <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Morbi non viverra risus. Vestibulum at augue sed odio
                    sagittis accumsan quis eget felis. Praesent tempor dolor
                    lorem, id consequat leo tincidunt quis. Pellentesque ut
                    efficitur ipsum. Quisque finibus nunc ut metus molestie, a
                    dapibus lacus semper. Pellentesque neque ipsum, iaculis eget
                    dolor a, tempus elementum nisi. Nunc sem velit, elementum eu
                    euismod in, viverra nec metus. Curabitur sed felis id purus
                    viverra ultrices. Vestibulum porttitor tellus ut diam
                    consectetur porta.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Morbi non viverra risus. Vestibulum at augue sed odio
                    sagittis accumsan quis eget felis. Praesent tempor dolor
                    lorem, id consequat leo tincidunt quis. Pellentesque ut
                    efficitur ipsum. Quisque finibus nunc ut metus molestie, a
                    dapibus lacus semper. Pellentesque neque ipsum, iaculis eget
                    dolor a, tempus elementum nisi. Nunc sem velit, elementum eu
                    euismod in, viverra nec metus. Curabitur sed felis id purus
                    viverra ultrices. Vestibulum porttitor tellus ut diam
                    consectetur porta.
                  </p>
                
                 `}
          title={"Re:Template"}
          copiedInstitutionContent={"MIFOTRA"}
        />
      </div>
    </>
  );
};

const mapStateToProps = ({
  loading,
  onWait,
  letterCustomization,
  selectedPlanningEntityId,
  user,
}) => {
  return {
    loading,
    onWait,
    letterCustomization,
    selectedPlanningEntityId,
    user,
  };
};
export default connect(mapStateToProps, {
  getLetterCustomization,
})(LetterTemplateDialog);
